import React from 'react';
import { Link } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import {
  Typography,
  Grid,
  Hidden,
  Chip,
  Paper,
} from '@material-ui/core';

import classes from '../../css/getCSS';
import * as constants from '../../config/constants';
import * as routes from '../../config/routes';

const searchItem = (props) => {
  const avatarURL = constants.BASE_URL + props.avatar;
  return (
    <Link className={classes.linkDeCSS} to={formatRoute(routes.VIEW_PROFILE, { uuid: props.slug })} target="_blank">
      <Paper className={[classes.card, classes.noPadding].join(' ')} style={{ marginBottom: '10px' }}>
        <Grid container>
          <Grid item md={3} sm={3} xs={12} className={classes.searchAvatarWrapper}>
            <Hidden smUp>
              <Chip className={classes.profileIDChipMobile} label={props.profile_id} />
            </Hidden>
            <img src={avatarURL} alt={props.slug} className={classes.searchAvatar} />
          </Grid>
          <Grid item md={9} sm={9} xs={12} className={classes.resultsDataWrapper}>
            <Hidden xsDown>
              <Chip className={classes.profileIDChip} label={props.profile_id} />
            </Hidden>
            <Typography variant="body1" className={classes.resultsTitle}>{props.first_name} {props.last_name}</Typography>
            <Grid container>
              <Grid item md={6} sm={6} xs={6}>
                <Typography className={classes.resultsData} variant="body1">{props.birth_date}</Typography>
              </Grid>
              <Grid item md={6} sm={6} xs={6}>
                <Typography className={classes.resultsData} variant="body1">{props.height.name}</Typography>
              </Grid>
              <Grid item md={6} sm={6} xs={6}>
                <Typography className={classes.resultsData} variant="body1">{props.marital_status.name}</Typography>
              </Grid>
              <Grid item md={6} sm={6} xs={6}>
                <Typography className={classes.resultsData} variant="body1">{props.caste.name}</Typography>
              </Grid>
              <Grid item md={6} sm={6} xs={6}>
                <Typography className={classes.resultsData} variant="body1">{props.qualification.name}</Typography>
              </Grid>
              <Grid item md={6} sm={6} xs={6}>
                <Typography className={classes.resultsData} variant="body1">{props.work_profile.name}</Typography>
              </Grid>
              <Grid item md={6} sm={6} xs={6}>
                <Typography className={classes.resultsData} variant="body1">{props.income.name}</Typography>
              </Grid>
              <Grid item md={6} sm={6} xs={6}>
                <Typography className={classes.resultsData} variant="body1">{props.city ? props.city.name : null}</Typography>
              </Grid>
              <Grid item md={6} sm={6} xs={6}>
                {props.is_complete
                  ? <Typography className={classes.resultsData} variant="body1">Active: {props.last_login ? props.last_login_natural : 'Never'}</Typography>
                  : <Typography className={classes.resultsData} variant="body1" style={{ color: 'red' }}>Profile Inactive</Typography>}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Link>
  );
};

export default searchItem;



// WEBPACK FOOTER //
// ./src/search/components/SearchItem.js